"use strict";

document.addEventListener("DOMContentLoaded", function (event) {

    $(".topic-section").each(function (index, el) {
        var $section = $(el);
        var $indexElement = $section.find(".topic-section-index");
        var $contents = $section.find(".topic-section-contents").children();
        $contents.each(function (i, e) {
            if (e.tagName.match(/H[1-5]/)) {
                var $heading = $(e);
                var anchorName = "topic-" + index + "-" + i;
                var $indexItem = $('<li/>');
                var $indexItemLink = $('<a/>').attr("href", "#" + anchorName).html($heading.text());
                $indexItem.append($indexItemLink);
                $indexElement.append($indexItem);
                var $anchorElement = $('<a/>').attr("name", anchorName);
                $heading.prepend($anchorElement);
            }
        });
    });

});